import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomEtapas extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.successTablaItemFichas     = this.successTablaItemFichas.bind(this);
        this.setButtonDelete            = this.setButtonDelete.bind(this);
        this.setButtonDeleteAgregado    = this.setButtonDeleteAgregado.bind(this);
        this.successDelete              = this.successDelete.bind(this);
        this.uploadTable                = this.uploadTable.bind(this);
        this.deleteEspecification       = this.deleteEspecification.bind(this);
        this.tamanoDatos                = 0;
        this.id_item_add                = 0;
        this.cantidad_max               = 0;
        this.agregarCantidad            = this.agregarCantidad.bind(this);
        this.cantidadChange             = this.cantidadChange.bind(this);
        this.successAddItem             = this.successAddItem.bind(this);
        this.grabarItem                 = this.grabarItem.bind(this);
        this.formato                    = this.formato.bind(this);
        this.formato2                   = this.formato2.bind(this);
        this.formato4                   = this.formato4.bind(this);
        this.valido                     = true;
        this.observacion                = '';
        this.etapa_id                   = 0;
        this.lote                       = '';
        this.abastecimiento             = '';
        this.gridOptions3               = Object.assign({},this.gridOptions);
        this.gridOptions2               = Object.assign({},this.gridOptions);
        this.onSelectionChangedVacio    = this.onSelectionChangedVacio.bind(this);
        this.gridOptions3['onSelectionChanged'] = this.onSelectionChangedVacio;
        this.successDatosFicha          = this.successDatosFicha.bind(this);
        this.traerDatosFichas           = this.traerDatosFichas.bind(this);
        this.etapaActualFicha           = this.etapaActualFicha.bind(this);
        this.verFormula                 = this.verFormula.bind(this);
        this.successVerFormula          = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula      = Object.assign({}, this.gridOptions);
        this.successClose               = this.successClose.bind(this);
    }

    onSelectionChangedVacio(){

    }

    initForm() {
        console.log('Etapas @Author: Juan David Nieto @Version: 1.01.0054; @updateBy: Sebastian Rios Echverri');
        this.traerDatosFichas();
       //this.service.send(this.getConstant().searchFormat().format(this.props.data.id_ficha,"tablaEtapas",'servicio',this.formId), 'GET', undefined ,this.successTablaItemFichas,this.error_);
        this.getField('btnTerminarEtapa').setClick(this.grabarItem);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    traerDatosFichas(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_traer_datos_ficha_etapas'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successDatosFicha,
                error: this.error_,
                general: this.generalFormat
            });  */
    }
    etapaActualFicha(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'itemsetapaactual', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_produccion_fichas_items_etapa_actual'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat
            }); */
    }        


    successDatosFicha(data){
        let datosFicha = [];
        if(data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaFichaEtapas').setVisible(true);
            datosFicha.push(data.data[0]);
            this.getField('listaFichaEtapas').setItemsFichas(datosFicha);
            this.etapaActualFicha();
        } else{
            this.getField('listaFichaEtapas').setVisible(false);
            this.etapaActualFicha();
        }
    }

    formato(props){
        return ("".formatoPrecio(props.data.cantidad_galones));
    }

    formato3(props){
        return ("".formatoPrecio(props.data.cantidad_en_kilos));
    }

    formato2(props){
        return ("".formatoPrecio(props.data.cantidad_restante));
    }

    formato4(props){
        let valor_actual = props.data.cantidad_agregada;
        if(valor_actual === null || valor_actual === 0)
            this.valido = false;
        let div = document.createElement("div");
        let label = document.createElement("label");
        label.textContent = "".formatoPrecio(valor_actual);
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    successTablaItemFichas(data){
        if(data.estado_p === 200){
            if(data.model[0].items.length > 0){
                let configCell = new Map();
                this.tamanoDatos = data.model[0].items.length;
                configCell.set('cantidad_galones',{cellRenderer:this.formato, cellStyle: { textAlign: "right" },field: 'cantidad_galones',width: 160 });
                configCell.set('lote',{field: 'lote',width: 120 });
                configCell.set('codigo',{field: 'codigo',width: 120 });
                configCell.set('cantidad_kilos',{field: 'cantidad_kilos',width: 150 });
                configCell.set('nombre_unidad',{field: 'nombre_unidad',width: 150 });
                configCell.set('bodega',{field: 'bodega',width: 130 });
                configCell.set('cantidad_en_kilos',{cellRenderer:this.formato3, cellStyle: { textAlign: "right" },field: 'cantidad_en_kilos',width: 160 });
                configCell.set('cantidad_restante',{cellRenderer:this.formato2,cellStyle: { textAlign: "right"},field: 'cantidad_restante',width: 160});
                configCell.set('cantidad_agregada',{cellRenderer:this.formato4,cellStyle: { textAlign: "right",backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' },singleClickEdit: true,field: 'cantidad_agregada', editable:true, onCellValueChanged:this.cantidadChange,width: 170 });
                this.gridOptions3['rowData'] = data.model[0].items;
                this.getField('tablaEtapas').initData(this.gridOptions3,configCell);
            }else
                this.getField('tablaEtapas').toggle(false);
        }
    }

    setButtonDeleteAgregado(props){
        let id = props.data.id;
        let button = document.createElement("input"); 
        button.onclick = ()=>this.deleteEspecification(id);
        button.setAttribute("id",'button_deleteAgregado_'+id);
        button.setAttribute("class","buttonStyle");//,"width:100%;height:100%;background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Eliminar");
        return this.createElementJaivana(button);
    }


    /**
     * Función encargada de realizar la peticion DELETE al servidor
     * @param {int} id Id de la ficha seleccionada en la tabla  
     */
    deleteEspecification(id){
        this.successDeleteCustom = this.successDelete;
        let datos = {
            accion:'servicio',
            campo:'tablaAgregados',
            id_formulario: this.formId,
            id: id,
            actividad_id:this.props.data.actividad_id

        };
        this.data = datos;
        this.getField('modalDelete').toggle(true);
    }

    /**
     * 
     * @param {json} model respuesta del servidor al DELETE, si es 200 se actualiza la tabla 
     */
    successDelete(model){
        if(model.estado_p ===undefined || model.estado_p ===200){
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success");
            this.uploadTable();
        }
    }

    cantidadChange(props){
        let cantUser = props.newValue;
        if(parseFloat(cantUser) && parseFloat(cantUser) > 0 && cantUser !== ''){
            let idCell = props.data.id;
            let cantAnt = props.data.cantidad_galones;
            if(cantUser <= cantAnt && cantUser <= props.data.cantidad_galones)
                this.agregarCantidad(cantUser,idCell);
            else{
                props.newValue = 0;
                this.alertGeneral.toggle(true,'El valor ingresado no puede superar el valor de Cantidad',"error");
                this.gridOptions3.rowData[parseInt(props.node.id)][props.column.colId] = parseFloat(props.oldValue);
                //this.getField('tablaEtapas').refresh(this.gridOptions);
            }
        }else{
            if(parseFloat(props.oldValue))
                this.gridOptions3.rowData[parseInt(props.node.id)][props.column.colId] = parseFloat(props.oldValue);
            else 
                this.gridOptions3.rowData[parseInt(props.node.id)][props.column.colId] = 0;
            //this.getField('tablaEtapas').refresh(this.gridOptions);
            this.alertGeneral.toggle(true,'El campo no cumple con el formato deseado',"error");
        }
    }

    agregarCantidad(cantidad,idCell){
        
       /* let data = {
            accion:'f9_servicio',
            campo:'tablaEtapas',
            id_formulario: this.formId,

        }*/
        let datos = {
            datos:{
                produccion_fichas_id: this.props.data.id_ficha,
                produccion_fichas_items_id: idCell,
                cantidad: parseFloat(cantidad),
                actividad_id: this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'marcaritem', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successAddItem,
            error: this.error_,
            general: this.generalFormatPmv
        });
        
        /*this.generalFormat.nombre_accion = 'servicio_marcar_item_fichas_etapas_2'; //nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successAddItem,
                error: this.error_,
                general: this.generalFormat
            }); */       
       //this.service.send(this.getConstant().formSave(), 'PUT', data ,this.successAddItem,this.error_);
    }

    setButtonDelete(props){
        let id = props.data.id;
        let cantidad = props.data.cantidad_restante;
        let button = document.createElement("input"); 
        button.onclick = ()=>this.addEspecification(id,cantidad);
        button.setAttribute("id",'button_delete_'+id);
        button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Agregar");
        return this.createElementJaivana(button);
    }

    successAddItem(data){
        if(data.estado_p === 200)
            this.uploadTable();
    }

    uploadTable(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'itemsetapaactual', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
       //this.service.send(this.getConstant().searchFormat().format(this.props.data.id_ficha,"tablaEtapas",'servicio',this.formId), 'GET', undefined ,this.successTablaItemFichas,this.error_);
    }

    grabarItem(){
        /**let data = {
            accion:'servicio',
            campo:'btnTerminarEtapa',
            id_formulario: this.formId,

        }*/
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                produccion_fichas_id: this.props.data.id_ficha,
                proceso_id: this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id,
                puntos: this.props.data.puntos
            }
        }
        this.getField('btnTerminarEtapa').setDisabled(true);
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'continuar', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_marcarsigte_etapa_fichas_etapas_2'; // servicio_traer_datos_ficha_etapas nombre_accion: es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: body,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormat
            });*/
       //this.service.send(this.getConstant().formSave(), 'PUT', data  ,this.successCloseEstage,this.error_); el servicio viejo utilizaba un PUT
    }

    successClose(data){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('btnTerminarEtapa').setDisabled(false);
        this.successCloseEstage(data);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }
}


FormJaivana.addController("prod-etapas",CustomEtapas);

export default CustomEtapas;